export default {
    getConsultantInfo: {
        url: '/base/baseconsultant/detail',
        method: 'get'
    },
    getConsultantCourse: {
        url: '/base/baseconsultant/getConsultantCourse',
        method: 'get'
    },
    saveShareCount: {
        url: '/base/baseconsultant/shareCount',
        method: 'get'
    },
    getConsultantStudent: {
        url: '/base/baseconsultant/getConsultantCustomer',
        method: 'get'
    },
    getConPublishStatistics: {
        url: '/crm/studentsignup/getConPublishStatistics',
        method: 'get'
    },
}
